import EditDetailsLink from './EditDetailsLink';

export default EditDetailsLink;
